window.SubscriptionCartPolicy = {
  pendingOneTimeAdd: null,

  mixedCartMessage:
    'Não é permitido misturar compra única com assinatura. Escolha apenas um tipo de compra.',

  hasSubscription(cart) {
    return cart.items.some((item) => {
      const title = item.variant_title?.toLowerCase() || '';
      const properties = item.properties || {};

      return (
        properties._digi_subscription === 'true' ||
        title.includes('mensal') ||
        title.includes('2 meses') ||
        title.includes('3 meses') ||
        title.includes('bimestral') ||
        title.includes('trimestral')
      );
    });
  },

  isOneTimeProduct(productTitle = '') {
    const title = productTitle.toLowerCase();

    return (
      title.includes('única') ||
      title.includes('unica') ||
      title.includes('compra avulsa')
    );
  },

  isMixedCartError(error) {
    let payload = error;

    if (error?.responseText) {
      try {
        payload = JSON.parse(error.responseText);
      } catch (_) {
        payload = {
          description: error.responseText
        };
      }
    }

    const message = [
      payload?.message,
      payload?.description,
      payload?.errors,
      typeof payload === 'string' ? payload : ''
    ]
      .filter(Boolean)
      .join(' ')
      .toLowerCase();

    return (
      message.includes('não é permitido misturar compra única com assinatura') ||
      (
        message.includes('compra única') &&
        message.includes('assinatura')
      )
    );
  },

  ensureAlert() {
    let alert = document.querySelector('[data-digi-subscription-alert]');

    if (alert) {
      return alert;
    }

    alert = document.createElement('div');
    alert.className = 'digi-subscription-alert';
    alert.setAttribute('data-digi-subscription-alert', '');
    alert.setAttribute('aria-hidden', 'true');

    alert.innerHTML = `
      <button
        type="button"
        class="digi-subscription-alert__overlay"
        data-digi-subscription-alert-close
        aria-label="Fechar alerta"
      ></button>

      <div
        class="digi-subscription-alert__dialog"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="digi-subscription-alert-title"
        aria-describedby="digi-subscription-alert-description"
      >
        <button
          type="button"
          class="digi-subscription-alert__close"
          data-digi-subscription-alert-close
          aria-label="Fechar alerta"
        >×</button>

        <span class="digi-subscription-alert__eyebrow">ATENÇÃO</span>

        <h2
          class="digi-subscription-alert__title"
          id="digi-subscription-alert-title"
        >
          Seu carrinho contém produtos de assinatura
        </h2>

        <p
          class="digi-subscription-alert__description"
          id="digi-subscription-alert-description"
        >
          Você não pode mesclar com um item de compra única. Primeiro limpe os itens de assinatura do carrinho.
        </p>

        <div class="digi-subscription-alert__actions">
          <button
            type="button"
            class="digi-subscription-alert__button digi-subscription-alert__button--keep"
            data-digi-subscription-alert-close
          >
            NÃO, CONTINUAR ASSINATURA
          </button>

          <button
            type="button"
            class="digi-subscription-alert__button digi-subscription-alert__button--clear"
            data-digi-subscription-alert-clear
          >
            Limpar carrinho
          </button>
        </div>
      </div>
    `;

    document.body.appendChild(alert);

    alert
      .querySelectorAll('[data-digi-subscription-alert-close]')
      .forEach((button) => {
        button.addEventListener('click', () => this.closeMixedCartAlert());
      });

    alert
      .querySelector('[data-digi-subscription-alert-clear]')
      ?.addEventListener('click', () => this.clearCartAndContinue());

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && alert.classList.contains('is-active')) {
        this.closeMixedCartAlert();
      }
    });

    return alert;
  },

  showMixedCartAlert({ onClear } = {}) {
    if (typeof onClear === 'function') {
      this.pendingOneTimeAdd = onClear;
    }

    const alert = this.ensureAlert();

    alert.classList.add('is-active');
    alert.setAttribute('aria-hidden', 'false');
    document.body.classList.add('digi-subscription-alert-open');

    window.requestAnimationFrame(() => {
      alert
        .querySelector('[data-digi-subscription-alert-clear]')
        ?.focus();
    });
  },

  closeMixedCartAlert() {
    const alert = document.querySelector('[data-digi-subscription-alert]');

    alert?.classList.remove('is-active');
    alert?.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('digi-subscription-alert-open');
    this.pendingOneTimeAdd = null;
  },

  async clearCartAndContinue() {
    const alert = this.ensureAlert();
    const clearButton = alert.querySelector(
      '[data-digi-subscription-alert-clear]'
    );
    const pendingAction = this.pendingOneTimeAdd;

    if (clearButton) {
      clearButton.disabled = true;
      clearButton.textContent = 'Limpando...';
    }

    try {
      const response = await fetch(
        window.Shopify.routes.root + 'cart/clear.js',
        {
          method: 'POST',
          headers: {
            Accept: 'application/json'
          }
        }
      );

      if (!response.ok) {
        throw new Error('Não foi possível limpar o carrinho.');
      }

      this.pendingOneTimeAdd = null;
      this.closeMixedCartAlert();

      if (typeof pendingAction === 'function') {
        pendingAction();
      }
    } catch (error) {
      console.error('[SubscriptionCartPolicy]', error);

      if (clearButton) {
        clearButton.textContent = 'TENTAR NOVAMENTE';
      }
    } finally {
      if (clearButton) {
        clearButton.disabled = false;
      }
    }
  },

  validate({ cart, productTitle }) {
    const hasSubscription = this.hasSubscription(cart);
    const isOneTime = this.isOneTimeProduct(productTitle);

    if (hasSubscription && isOneTime) {
      this.showMixedCartAlert();
      return false;
    }

    return true;
  }
};
